import clsx from 'clsx';
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button } from '../Button';
import { useDescendant, useDescendantsContextSelector } from '../Descandants';
import { TabsDescendantsContext } from './Tabs';
import { useTabsTablistContext } from './TabsTabList';
import { useComposedRefs } from '../../utils';
export const TabsTab = React.memo(function TabsTab(props) {
    const { index: indexProp, label, description } = props;
    const { onSelect } = useTabsTablistContext();
    const [element, setElement] = useState(null);
    const buttonRef = useRef(null);
    const descendant = useMemo(() => ({ element }), [element]);
    const index = useDescendant(descendant, TabsDescendantsContext, indexProp);
    const active = useDescendantsContextSelector(TabsDescendantsContext, ({ activeIndex }) => activeIndex === index);
    const selected = useDescendantsContextSelector(TabsDescendantsContext, ({ selected }) => selected.findIndex((descendant) => descendant.index === index) !== -1 ||
        (selected.length === 0 && index === 0));
    useEffect(() => {
        if (active) {
            setTimeout(() => {
                var _a;
                (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                    inline: 'center',
                });
            }, 0);
        }
    }, [active]);
    return (React.createElement(Button, { unstyled: true, role: "tab", tabIndex: active ? 0 : -1, className: clsx('mollie-ui-tabs-tab', {
            'mollie-ui-tabs-tab--selected': selected,
        }), onClick: () => {
            onSelect(index);
        }, ref: useComposedRefs(setElement, buttonRef), "aria-selected": Boolean(selected), UNSAFE_contentClassName: "mollie-ui-tabs-tab-content" },
        label,
        description && (React.createElement("div", { className: "mollie-ui-tabs-tab-description" }, description))));
});
TabsTab.displayName = 'Tabs.Tab';
//# sourceMappingURL=TabsTab.js.map